import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name: 'user',
    // initialState: {
    //     user: null
    // },
    initialState: {
        user: {
            id: '1',
            name: 'robin',
            permissions: ['analyze'],
            roles: ['admin'],
        }
    },
    reducers: {
        login: (state, action) => {
            state.user = action.payload
        },
        logout: (state) => {
            state.user = null
        }
    }
})

export const { login, logout } = userSlice.actions;

export default userSlice.reducer;